/**
 * Gift wrap toggle
 * ----------------
 * Adds / removes the hidden "$5 Gift Wrap" add-on and refreshes the cart drawer
 * in place. Keyed off the VARIANT id (there is only ever one gift-wrap line), so
 * it never depends on a line key that can go stale after a re-render.
 *
 * Uses /cart/update.js for both on and off (idempotent qty 1 / 0).
 * Does NOT fire Meta AddToCart — gift wrap must not appear as an ad product.
 */
(function () {
  if (window.__irGiftWrapBound) return;
  window.__irGiftWrapBound = true;

  var GIFT_WRAP_VARIANT_ID = 42687836160097;
  var busy = false;

  function cartRoute(key, fallback) {
    return ((window.routes && window.routes[key]) || fallback) + '.js';
  }

  function cartBaseUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function giftWrapInCart(cart) {
    return (cart.items || []).some(function (item) {
      return Number(item.variant_id) === GIFT_WRAP_VARIANT_ID;
    });
  }

  function applyToggleUi(inCart) {
    var input = document.querySelector('[data-ir-giftwrap-toggle]');
    var card = document.querySelector('[data-ir-giftwrap]');
    if (input) {
      input.checked = !!inCart;
      input.disabled = false;
    }
    if (card) {
      card.classList.toggle('is-on', !!inCart);
      card.classList.remove('is-loading');
    }
  }

  function syncFromCart() {
    return fetch(cartBaseUrl() + '.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyToggleUi(giftWrapInCart(cart));
        return cart;
      });
  }

  // Re-fetch the cart-drawer section fresh and swap it in. This always reflects the
  // true cart state, so the toggle can't get stuck "on" after a remove.
  function refreshDrawer() {
    return fetch(cartBaseUrl() + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(function () {
        return fetch(cartBaseUrl() + '.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var drawer = document.querySelector('cart-drawer');
            if (!drawer) return cart;
            drawer.classList.toggle('is-empty', cart.item_count === 0);
            if (typeof drawer.syncHeaderCounts === 'function') {
              drawer.syncHeaderCounts(cart.item_count);
            }
            applyToggleUi(giftWrapInCart(cart));
            return cart;
          });
      });
  }

  function clearBusy() {
    busy = false;
    document.querySelectorAll('[data-ir-giftwrap].is-loading').forEach(function (el) {
      el.classList.remove('is-loading');
    });
    var input = document.querySelector('[data-ir-giftwrap-toggle]');
    if (input) input.disabled = false;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ir-giftwrap-toggle]')) return;

    // Browser already flipped the checkbox; undo if a request is in flight.
    if (busy) {
      input.checked = !input.checked;
      return;
    }

    var card = input.closest('[data-ir-giftwrap]');
    var variantId = Number(input.getAttribute('data-variant-id')) || GIFT_WRAP_VARIANT_ID;
    var wantOn = input.checked;

    busy = true;
    if (card) card.classList.add('is-loading');
    input.disabled = true;

    // Idempotent: set qty to 1 or 0 by variant id (avoids stuck state from /cart/change).
    var updates = {};
    updates[String(variantId)] = wantOn ? 1 : 0;

    postJSON(cartRoute('cart_update_url', '/cart/update'), { updates: updates })
      .then(function () {
        return refreshDrawer();
      })
      .catch(function (err) {
        console.warn('[ir-gift-wrap]', err);
        // Re-sync from real cart so UI never lies if the request failed mid-flight.
        return syncFromCart().catch(function () {
          if (input.isConnected) input.checked = !wantOn;
          if (card && card.isConnected) card.classList.remove('is-loading');
        });
      })
      .then(function () {
        clearBusy();
      });
  });
})();
